import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { FaBars, FaTimes } from "react-icons/fa";

const navLinks = [
  { label: "Home", to: "home" },
  { label: "About", to: "about" },
  { label: "Resume", to: "resume" },
  { label: "Skills", to: "skills" },
  { label: "Works", to: "works" },
  { label: "Contact", to: "contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  return (
    <header className={`header${scrolled ? " header--scrolled" : ""}`}>
      <div className="header__container">
        <Link
          to="home"
          smooth={true}
          duration={600}
          className="header__logo"
          onClick={() => setMenuOpen(false)}
        >
          AR<span>.</span>
        </Link>

        <nav className={`header__nav${menuOpen ? " header__nav--open" : ""}`}>
          {navLinks.map(({ label, to }) => (
            <Link
              key={to}
              to={to}
              smooth={true}
              duration={600}
              spy={true}
              activeClass="active"
              offset={-70}
              className="header__link"
              onClick={() => setMenuOpen(false)}
            >
              {label}
            </Link>
          ))}
        </nav>

        <button
          className={`header__hamburger${menuOpen ? " header__hamburger--open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>
    </header>
  );
}
